/* fx-loading.js: replaces the extension's typed-out waiting line on the VIN
   lookup with a calm crossfade. Timings were slowed on 22 Sep 2026: each line
   eases in over 520ms, holds for 1.6s, eases out over 420ms, with a short
   blur so the change reads as a dissolve rather than a cut. The outgoing
   fade holds its end state until the next line starts, so there is never a
   one frame flash of the new text at full opacity. */
(function () {
  "use strict";
  var IN_MS = 520, HOLD_MS = 1600, OUT_MS = 420, GAP_MS = 80;
  var EASE_IN = "cubic-bezier(.16, 1, .3, 1)";
  var EASE_OUT = "cubic-bezier(.45, 0, .55, 1)";
  function reduced() {
    return !!(window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches);
  }
  function wait(ms) { return new Promise(function (r) { setTimeout(r, ms); }); }
  function show(el, text, alive) {
    el.classList.remove("is-fading");
    if (reduced() || typeof el.animate !== "function") {
      el.textContent = text;
      return wait(HOLD_MS + IN_MS);
    }
    if (el._fxFall) { el._fxFall.cancel(); el._fxFall = null; }
    el.textContent = text;
    var rise = el.animate(
      [{ opacity: 0, transform: "translateY(4px)", filter: "blur(2px)" },
       { opacity: 1, transform: "translateY(0)", filter: "blur(0)" }],
      { duration: IN_MS, easing: EASE_IN, fill: "backwards" }
    );
    return rise.finished.catch(function () {})
      .then(function () { return wait(HOLD_MS); })
      .then(function () {
        if (!alive()) return null;
        var fall = el.animate(
          [{ opacity: 1, transform: "translateY(0)", filter: "blur(0)" },
           { opacity: 0, transform: "translateY(-3px)", filter: "blur(2px)" }],
          { duration: OUT_MS, easing: EASE_OUT, fill: "forwards" }
        );
        el._fxFall = fall;
        return fall.finished.catch(function () {}).then(function () { return wait(GAP_MS); });
      });
  }
  function patch(Ctor) {
    if (!Ctor || !Ctor.prototype || Ctor.prototype.fxCalmLoading) return;
    Ctor.prototype.fxCalmLoading = true;
    Ctor.prototype.runVinLoadingTextCycle = async function (token) {
      var el = this.getModalElement && this.getModalElement("#vinLoadingText");
      if (!el) return;
      var self = this;
      var alive = function () { return token === self._loadingTextToken; };
      var vin = this._loadingVin;
      var subject = vin ? "Matching VIN " + vin : this._loadingLabel ? "Matching " + this._loadingLabel : "Matching your trailer";
      var phrases = ["Searching production records", subject, "Finding parts that fit"];
      var i = 0;
      while (alive()) {
        await show(el, phrases[i % phrases.length], alive);
        if (!alive()) {
          if (el._fxFall) { el._fxFall.cancel(); el._fxFall = null; }
          return;
        }
        i += 1;
      }
    };
  }
  if (window.customElements && customElements.whenDefined) {
    customElements.whenDefined("vin-search-modal").then(function () {
      patch(customElements.get("vin-search-modal"));
    });
  }
})();
